import { ButtonLooks, FontIcons, StandardButton } from '@brandfolder/react';
import { Trans } from '@lingui/macro';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { shimmer } from './GenerativeAiImageCaptions';

const GenerateButton = styled(StandardButton)`
  background-color: transparent;
  min-height: unset;
  padding: 0;
  margin-bottom: 4px;

  &:active {
    background-color: transparent;
  }

  &:hover {
    &:not(.disabled) {
      background: linear-gradient(45deg, #5A79E5,  #9072E5, #5A79E5);
      background-clip: text;
      -webkit-background-clip: text;
    }

    .bf-button__standard__children {
      border-bottom: 1px solid #5A79E5;
      margin-bottom: -1px;
    }
  }

  &.disabled {
    opacity: 0.7;

    &:hover {
      .bf-button__standard__children {
        border-bottom: none;
        margin-bottom: 0;
      }
    }

    span {
      animation: none;
    }
  }

  span {
    animation: ${shimmer}  2s linear infinite;
    background: linear-gradient(135deg, #6486FF 0%, #A07EFF 79.04%);
    background-clip: text;
    font-weight: 500;
    background-size: calc(100% + 1000px) 100%;
    -webkit-background-clip: text;
    -webkit-animation: ${shimmer}  3s linear infinite;
    -webkit-text-fill-color: transparent;
  }

  .bf-icon {
    margin-right: 8px;
  }
`;

interface GenerateCaptionButtonProps {
  setShowGenerateCaption: (showGenerateCaption: boolean) => void;
  showGenerateCaption: boolean;
}

export const GenerateCaptionButton: FunctionComponent<GenerateCaptionButtonProps> = ({
  setShowGenerateCaption,
  showGenerateCaption,
}) => (
  <GenerateButton
    className={`${showGenerateCaption && 'disabled'}`}
    disabled={showGenerateCaption}
    look={ButtonLooks.TextSecondary}
    onClick={(): void => setShowGenerateCaption(true)}
    startIcon={FontIcons.SparkleFilled}
    type="button"
  >
    <Trans>Suggest description</Trans>
  </GenerateButton>
);
